var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useErrorMonitor } from './useErrorMonitor';
export var withErrorMonitor = function (WrappedComponent) {
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'unknown';
    var Wrapped = function (props) {
        var errorMonitor = useErrorMonitor();
        return React.createElement(WrappedComponent, __assign({}, __assign(__assign({}, props), { errorMonitor: errorMonitor })));
    };
    Wrapped.displayName = "withErrorMonitor(".concat(componentDisplayName, ")");
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    hoistNonReactStatics(Wrapped, WrappedComponent);
    return Wrapped;
};
//# sourceMappingURL=withErrorMonitor.js.map